module.exports = __webpack_public_path__ + "static/rb-165633d7b7f670224fbb9e1e9cb96bd5.jpg";